<div class="card">
  <div class="card-body">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Web</th>
          <th scope="col">Android</th>
          <th scope="col">IOS</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Today</td>
          <td>{{notificationCount.Today.web}}</td>
          <td>{{notificationCount.Today.android}}</td>
          <td>{{notificationCount.Today.ios}}</td>
        </tr>
        <tr>
          <td>Yesterday</td>
          <td>{{notificationCount.Yesterday.web}}</td>
          <td>{{notificationCount.Yesterday.android}}</td>
          <td>{{notificationCount.Yesterday.ios}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

  <input type="text" value="" class="heightzero" #clipboardInput>
  <div class="tabcontainer-data">
    <div class="searchBlock"> 
      <div class="searchSection">
        <i class="icon-search"></i>
        <div class="searchtxt">
          <input #listingInput id="searchInputBox"class="search-components textBox" type="text" [placeholder]="placeholder" [(ngModel)]="str"
            (keydown)="onKeydown($event, listingInput)" (focus)="searchFocus = true" (focusout)="searchFocus = false"
            autofocus />
            <ng-container *ngIf="listSuggestionArray && listSuggestionArray.length > 0">
              <div [ngClass]="(showSuggestionBox) ? 'block' : '' " class="autosuggestion" *ngIf="listSuggestionArray">
                <ul>
                  <ng-container *ngFor="let item of listSuggestionArray; let i = index ; trackBy: trackByName; ">
                    <li [class.active]="i == arrowkeyLocation">
                      <span class="name" (click)="getsearchResults(item)">{{item}}</span>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </ng-container>
        </div>
      </div>
      <div class="filterSection spImg">
        <i class="icon-filter"></i>
        <div class="fliterBlock">
          <div class="searchfilter">
            <span [class]="exactMatch ? 'exact green' : 'exact'" (click)="toggleSwitch('exact')" tabindex="0"
              (keydown)="callToggles($event, 'exact')" id="searchFilter">
              Exact & Latest
            </span>
          </div>
          <ul class="filterOption">
            <ng-container *ngIf="filterList && facets">
              <ng-container *ngFor="let filter of filterList;let i = index">
                <li [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
                  <filter [filterType]="filter.type" [displayName]="filter.name"
                    [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                    [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                    [filterId]="filter.filter_id" (filterSelect)="urlNotificationUpdate($event)"></filter>
                </li>
                <span #moreButtonEl tabindex="0"
                  [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                  (click)="(showMore = !showMore)"
                  *ngIf="(filterList.length > 4 ) && i === 3">{{(showMore) ? 'less' : 'more'}}</span>
              </ng-container>
            </ng-container>
          </ul>
        </div>
      </div>
      <div class="closebg"></div>
    </div>
  
    <div class="storyMobScroll">
    <div class="headingsList" >
      <ul>
        <ng-container *ngFor="let header of headerList">
          <li [class]="header.class">{{header.name}}</li>
        </ng-container>
      </ul>
    </div>
    <div class="contentList">
      <ng-template #loading>
        <div style="text-align: center; display: inline-block; width: 100%;">
          <ng-container *ngIf="callFail">
            <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
              Sorry, Server Error
            </div>
          </ng-container>
          <ng-container *ngIf="!callFail">
            <div class="imagepreloader">
              <div class="a" style="--n: 5;">
                <div class="dot dot1" style="--i: 0;"></div>
                <div class="dot dot2" style="--i: 1;"></div>
                <div class="dot dot3" style="--i: 2;"></div>
                <div class="dot dot4" style="--i: 3;"></div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-template>
  
      <ng-template #nores>
        <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
      </ng-template>
      <ng-container *ngIf="noresults == false;then list else nores"></ng-container>
      <ng-template #list>
        <ng-container *ngIf="notificationListArray.length>0;else loading">
          <ng-container>
            <ng-container>
              <ng-container *ngFor="let item of notificationListArray; trackBy: trackByName; let i = index">
                <ul tabindex="0" class="locked rssfeedul">
       
                  <li id="headlineColumn" class="headline" [title]="item.title">
                    <div class="relhidden">
                      <div class="listCell">{{item.title}}</div>
                    </div>
                  </li> 
   
                  <li id="agencyColumnFeedList" class="description" [title]="item.description">
                    <div class="relhidden">
                      <div class="listCell">{{item.description}}</div>
                    </div>
                  </li>
  
                  <li id="sectionColumnFeedList" class="createdDate" [title]="item.createdDate">
                    <div class="relhidden">
                      <div class="listCell">{{getNewTypeDate(item.createdDate)}}</div>
                    </div>
                  </li>
  
                  <li id="sectionColumnFeedList" class="type" [title]="item.notificationType">
                    <div class="relhidden">
                      <div class="listCell">{{item.notificationType}}</div>
                    </div>
                  </li>
  
                  <li id="sectionColumnFeedList" class="type" [title]="item.appTypes">
                    <div class="relhidden">
                      <div class="listCell">
                        <ng-container *ngFor="let imgItem of item.appTypes">
                          <img *ngIf="imgItem==='Android'" src="../../../assets/images/Android.svg" width="15px"/>
                          <img *ngIf="imgItem==='Iphone'" src="../../../assets/images/apple-icon.svg" width="15px"/>
                          <img *ngIf="imgItem==='Web'" src="../../../assets/images/monitor-icon.svg" width="15px"/>
                        </ng-container>
                      </div>
                    </div>
                  </li>
  
                  <li id="sectionColumnFeedList" class="type" [title]="item.createdByUserName">
                    <div class="relhidden">
                      <div class="listCell">{{item.createdByUserName}}</div>
                    </div>
                  </li>
  
                  <li id="sectionColumnFeedList" class="type" [title]="item.storyTitle">
                    <div class="relhidden">
                      <div class="listCell"><a class="story-title" (click)="openStory(item.storyId)">{{item.storyTitle}}</a></div>
                    </div>
                  </li>
  
                </ul>
              </ng-container>
            </ng-container>
            </ng-container>
  
        </ng-container>
      </ng-template>
    </div>
    </div>
  
    <div class="footerPagination">
      <div class="pagination" *ngIf="totalRecords>50">Page
        <ul>
          <ng-container *ngIf="7 > pages">
            <ng-container *ngFor="let j of arrayOne(pages); let i = index">
              <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="pages > 6">
            <ng-container *ngFor="let j of arrayOne(pages); let i = index">
              <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)">
                <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
              </ng-container>
            </ng-container>
            <li>..</li>
            <li [class]="pageNum == (pages-1) ? 'active' : ''" (click)="onPageNumberChange(pages - 1)">{{(pages)}}</li>
          </ng-container>
        </ul>
      </div>
  
      <ng-container *ngIf="totalRecords < 50;then displayPaging else showPaging"></ng-container>
      <ng-template #showPaging>
        <div class="recordList">Showing
          <select name="recordList" class="select-wrapper" [(ngModel)]="pageSize"
            (ngModelChange)="onPageSizeChange($event)">
            <option *ngFor="let c of pageSizeArray" [ngValue]="c"> {{c}} </option>
          </select>results of {{totalRecords}}
        </div>
      </ng-template>
      <ng-template #displayPaging>
        <div id="dropDownRecordListInPagination" class="recordList borderNone">
          Showing {{totalRecords}} results</div>
      </ng-template>
    </div>
  </div>